import { SHTypography } from "@components/design-systems";
import { MAAnalysisDataDTO } from "@models/managed-accounts/entities/step/fee";
import { memo } from "react";
import { PerformanceNumberCell } from "../../value-renders/performance-number-cell";

interface GroupSubProductValueCellProps {
  analysisData: MAAnalysisDataDTO;
}

export const GroupSubProductValueCell = memo(
  ({ analysisData }: GroupSubProductValueCellProps) => {
    return (
      <PerformanceNumberCell
        {...analysisData}
        percentageDecimalPlaces={3}
        currencyDecimalPlaces={2}
        renderValue={(value: string) => (
          <SHTypography variant={"subtitle2"} lineHeight={"120%"} fontSize={13}>
            {value}
          </SHTypography>
        )}
      />
    );
  },
);
